





































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { JsonServiceClient, toFormData } from '@servicestack/client';
import WizardMenu from '../WizardMenu.vue';
import DataRepoInfo from './DataRepoInfo.vue';
import DataRepoProject from './DataRepoProject.vue';
import Submission from './Submission.vue';
import { redirect, Routes } from '../../shared/router';
import { bus, store, client, getUserInfo } from '../../shared';
import {
  DataProject,
  DataProjectMiscDoc,
  DataProjectDegreeSelection,
} from '../../shared/dataProject';
import { UserInfo } from '../../shared/user';
import _ from 'lodash';
@Component({
  components: {
    WizardMenu,
    DataRepoInfo,
    DataRepoProject,
    Submission,
  },
})
export default class Data extends Vue {
  $v: any;
  $bvToast: any;
  file: any = {};
  asyncState: null;
  resetFile: boolean = false;
  activeSession: any = {};
  isInvestigator: boolean = true;
  hasResearchArea: boolean = false;
  // hasFunding: boolean = false;
  form: any = {
    userId: '',
    rowId: 0,
    firstName: '',
    lastName: '',
    // degree: '',
    title: '',
    dataProjectId: '',
    hasORCID: false,
    rsnNoORCID: null,
    orcid: null,
    institution: '',
    email: '',
    phone: '',
    addressline1: null,
    addressline2: null,
    city: null,
    state: null,
    country: null,
    stateOther: null,
    province: null,
    zip: null,
    projectTitle: null,
    projectSummary: null,
    fundingAvailable: false,
    supportType: null,
    supportTypeOther: null,
    grantNumber: null,
    projectEndMonth: '',
    projectEndYear: '',
    cellStimulus: false,
    cellDeath: false,
    type1Diabetes: false,
    tissueEngineering: false,
    alphaCells: false,
    geneticsGenomics: false,
    otherArea: false,
    otherAreaText: null,
    phoneExt: null,
    finalSubmissionDate: '',
    personId: '',
    role: '',
    submit: false,
    part1complete: false,
    part2complete: false,
    submitted1: false,
  };
  record: any = {};
  steps: any = ['DataRepoInfo', 'DataRepoProject'];
  menuItems: any = [
    {
      id: 1,
      title: 'Investigator Profile',
      subTitle: 'Your Profile Information',
      isValid: false,
      disabled: false,
    },
    {
      id: 2,
      title: 'Study Details',
      subTitle: 'Study-specific details',
      isValid: false,
      disabled: false,
    },
  ];
  currentStepNumber: number = 1;
  iidpIsletStudyDashboard: string;
  iidpDataStudyDashboard: string;
  get currentStep() {
    return this.steps[this.currentStepNumber - 1];
  }
  processMenuSelection(id: number) {
    this.currentStepNumber = id;
    this.performSave();
  }
  get length() {
    return this.steps.length;
  }
  get validateSteps() {
    return this.menuItems[0].isValid && this.menuItems[1].isValid;
  }
  get userSession() {
    return store.userSession;
  }
  goBack() {
    this.currentStepNumber--;
  }
  goNext() {
    this.currentStepNumber++;
  }
  updateAsyncState(state: any) {
    this.asyncState = state;
  }
  onIsInvestigatorChanged(value: boolean) {
    this.isInvestigator = value;
    this.menuItems[1].disabled = !value;
    this.validateSteps();
  }
  onResearchAreaChanged(value: boolean) {
    this.hasResearchArea = value;
  }
  async performSave() {
    const d = await client.post(
      new DataProject({
        rowId: this.form.rowId,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        title: this.form.title,
        dataProjectId: this.form.dataProjectId,
        hasORCID: this.form.hasORCID,
        rsnNoORCID: this.form.rsnNoORCID,
        orcid: this.form.orcid,
        institution: this.form.institution,
        email: this.form.email,
        phone: this.form.phone,
        addressline1: this.form.addressline1,
        addressline2: this.form.addressline2,
        city: this.form.city,
        state: this.form.state,
        country: this.form.country,
        stateOther: this.form.stateOther,
        province: this.form.province,
        zip: this.form.zip,
        projectTitle: this.form.projectTitle,
        projectSummary: this.form.projectSummary,
        fundingAvailable: this.form.fundingAvailable,
        supportType: this.form.supportType,
        supportTypeOther: this.form.supportTypeOther,
        grantNumber: this.form.grantNumber,
        projectEndMonth: this.form.projectEndMonth,
        projectEndYear: this.form.projectEndYear,
        cellStimulus: this.form.cellStimulus,
        cellDeath: this.form.cellDeath,
        type1Diabetes: this.form.type1Diabetes,
        tissueEngineering: this.form.tissueEngineering,
        alphaCells: this.form.alphaCells,
        geneticsGenomics: this.form.geneticsGenomics,
        otherArea: this.form.otherArea,
        otherAreaText: this.form.otherAreaText,
        phoneExt: this.form.phoneExt,
        personId: this.form.personId,
        submit: this.form.submit,
        part1complete: this.form.part1complete,
        part2complete: this.form.part2complete,
        submitted1: this.form.submitted1,
        finalSubmissionDate: this.form.finalSubmissionDate,
      }),
    );
    Object.assign(this.form, d.result);

    if (this.userInfo.data.form) {
      Object.assign(this.userInfo.data.form, d.result);
    }
    setTimeout(() => {
      this.fileUpload(this.file);
      this.resetFile = !this.resetFile;
      getUserInfo();
      this.processDataProjectPIDegrees();
      this.$bvToast.toast(`Record successfully saved.`, {
        title: 'Save Result',
        variant: 'info',
        autoHideDelay: 2000,
      });
    }, 2000);
  }

  async performSaveStep() {
    const d = await client.post(
      new DataProject({
        rowId: this.form.rowId,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        title: this.form.title,
        dataProjectId: this.form.dataProjectId,
        hasORCID: this.form.hasORCID,
        rsnNoORCID: this.form.rsnNoORCID,
        orcid: this.form.orcid,
        institution: this.form.institution,
        email: this.form.email,
        phone: this.form.phone,
        addressline1: this.form.addressline1,
        addressline2: this.form.addressline2,
        city: this.form.city,
        state: this.form.state,
        country: this.form.country,
        stateOther: this.form.stateOther,
        province: this.form.province,
        zip: this.form.zip,
        projectTitle: this.form.projectTitle,
        projectSummary: this.form.projectSummary,
        fundingAvailable: this.form.fundingAvailable,
        supportType: this.form.supportType,
        supportTypeOther: this.form.supportTypeOther,
        grantNumber: this.form.grantNumber,
        projectEndMonth: this.form.projectEndMonth,
        projectEndYear: this.form.projectEndYear,
        cellStimulus: this.form.cellStimulus,
        cellDeath: this.form.cellDeath,
        type1Diabetes: this.form.type1Diabetes,
        tissueEngineering: this.form.tissueEngineering,
        alphaCells: this.form.alphaCells,
        geneticsGenomics: this.form.geneticsGenomics,
        otherArea: this.form.otherArea,
        otherAreaText: this.form.otherAreaText,
        phoneExt: this.form.phoneExt,
        personId: this.form.personId,
        submit: this.form.submit,
        part1complete: this.form.part1complete,
        part2complete: this.form.part2complete,
        submitted1: this.form.submitted1,
        finalSubmissionDate: this.form.finalSubmissionDate,
      }),
    );
    Object.assign(this.form, d.result);
    if (this.userInfo.data.form) {
      Object.assign(this.userInfo.data.form, d.result);
    }
    setTimeout(() => {
      this.processDataProjectPIDegrees();
      getUserInfo();
    }, 2000);
  }
  mounted() {
    this.loadToForm();
    const iidpSecureUrl = IIDPconfig.SECURE_URL as string;
    this.iidpIsletStudyDashboard = `${iidpSecureUrl}/${IIDPconfig.ISLET_STUDY_DASHBOARD as string}`;
    this.iidpDataStudyDashboard = `${iidpSecureUrl}/${IIDPconfig.DATA_STUDY_DASHBOARD as string}`;
  }
  async processDataProjectPIDegrees() {
    const d = await client.post(
      new DataProjectDegreeSelection({
        dataProjectRowId: this.form.rowId,
        degreeList: this.form.degrees,
        degreeOther: this.form.degreeOther,
      }),
    );
  }
  get userInfo() {
    return store.userInfo;
  }
  async fileUpload(file: any) {
    try {
      const fields = { id: 1, name: file.name };
      const body = toFormData({ ...fields, file });
      const checkDuplicate = _.findIndex(
        this.userInfo.data.docs,
        (o: any) => o.docName === file.name,
      );
      if (checkDuplicate === -1) {
        const doc = await client.postBody(
          new DataProjectMiscDoc({
            dataProjectRowId: this.form.rowId,
          }),
          body,
        );
      }
    } catch {
      /**/
    } finally {
      getUserInfo();
    }
  }
  submit() {
    if (this.validateSteps) {
      this.confirmSubmission();
    }
  }
  async confirmSubmission() {
    // if case the user selected a file and did not click save, upload the file first ONLY if the file is selected...
    this.$swal({
      title: 'Data Study Application Validator',
      text: 'Preparing data for submission...',
      icon: 'info',
      showCancelButton: false,
      showConfirmButton: false,
    });
    let doc;
    if (this.file !== undefined) {
      doc = await this.fileUpload(this.file);
    }
    // add a wait timing buffer for file upload
    setTimeout(() => {
      getUserInfo();
      // make sure the data submission has a supporting document
      // alert the user if theres no supporting document, otherwise, proceed with the submission
      if (
        store.userInfo.data !== undefined &&
        store.userInfo.data.docs.length === 0 &&
        this.file === null
      ) {
        this.$swal({
          title: 'Data Study Application Validator',
          text:
            'Supporting document is missing. Please attach the required documentaion before submission.',
        });
      } else {
        this.$swal({
          title: 'Data Study Application Submission',
          text:
            'You are about to submit your data study application. Do you wish to proceed?',
          icon: 'warning',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-info m-1',
            cancelButton: 'btn btn-secondary m-1',
          },
          confirmButtonText: 'Yes, submit my application!',
          html: false,
          preConfirm: () => {
            return new Promise((resolve: any) => {
              setTimeout(() => {
                resolve();
              }, 50);
            });
          },
        }).then(async (result: any) => {
          if (result.value) {
            this.$swal(
              'Submitted',
              'Your data study application has been submitted.',
              'success',
            );
            this.form.submit = true;
            this.performSave();
            redirect(Routes.Submission);
          } else if (result.dismiss === 'cancel') {
            this.performSave();
            this.$swal(
              'Cancelled',
              'Your submission will be cancelled.',
              'error',
            );
          }
        });
      }
    }, 500);
  }
  save() {
    if (this.form.firstName === '') {
      this.form.firstName = this.userInfo.userInfo.firstName;
    }
    if (this.form.lastName === '') {
      this.form.lastName = this.userInfo.userInfo.lastName;
    }
    if (this.form.institution === '') {
      this.form.institution = this.userInfo.userInfo.institution;
    }
    if (this.form.email === '') {
      this.form.email = this.userInfo.userInfo.email;
    }
    this.performSave();
    this.processDataProjectPIDegrees();
  }
  loadToForm() {
    bus.$on('userInfo', (payload: any) => {
      Object.assign(this.form, payload.data.form);
      this.activeSession = JSON.parse(
        localStorage.getItem(this.userInfo.userInfo.userName) || '{}',
      );
      if (!_.isEmpty(this.activeSession && payload.data.form === undefined)) {
        this.form.firstName = this.activeSession.firstName;
        this.form.lastName = this.activeSession.lastName;
        this.form.email = this.activeSession.email.slice(6);
        this.form.institution = this.activeSession.institution;
        this.form.addressline1 = this.activeSession.addressline1;
        this.form.addressline2 = this.activeSession.addressline2;
        this.form.city = this.activeSession.city;
        this.form.state = this.activeSession.state;
        if (this.activeSession.country !== undefined) {
          this.form.country = this.activeSession.country;
        }
        this.form.stateOther = this.activeSession.stateOther;
        this.form.province = this.activeSession.province;
        this.form.zip = this.activeSession.zip;
        this.form.phone = this.activeSession.phone;
        this.form.phoneExt = this.activeSession.phoneExt;
        this.form.personId = this.activeSession.personId;
        this.form.hasORCID = this.activeSession.hasORCID;
        this.form.rsnNoORCID = this.activeSession.rsnNoORCID;
        this.form.orcid = this.activeSession.orcid;
        this.form.title = this.activeSession.title;
        this.form.role = this.activeSession.role;
        this.form.rowId = this.activeSession.rowId;
        this.form.dataProjectId = this.activeSession.dataProjectID;
      }
    });
  }
  /* ------------- Lifecycle Hooks --------- */
  async created() {
    if (Object.keys(this.userInfo).length === 0) {
      const u = this.userSession!.userName;
      if (u !== undefined && u !== null && store.userSession != null) {
        const savedSession = JSON.parse(
          localStorage.getItem(store.userSession.userName) || '{}',
        );
        const d = await client.get(new UserInfo({ userName: u }));
        bus.$set(store, 'userInfo', d);
        bus.$emit('userInfo', d);
        if (
          this.userInfo.data !== undefined &&
          this.userInfo.data.form !== undefined
        ) {
          Object.assign(this.form, this.userInfo.data.form);
          setTimeout(() => {
            this.menuItems[0].isValid = !(this.$refs
              .currentStep as any).validateForm();
            if (
              this.userInfo.data.form.part1complete === true &&
              this.menuItems[0].isValid === true
            ) {
              this.menuItems[0].isValid = true;
              if (this.form.part1complete !== true) {
                this.form.part1complete = true;
                this.performSaveStep();
              } else {
                if (this.form.part1complete !== true) {
                  this.form.part1complete = false;
                  this.performSaveStep();
                }
              }
              if (this.userInfo.data.form.part2complete === true) {
                this.menuItems[1].isValid = true;
              }
            } else if (this.form.part1complete !== false) {
              this.form.part1complete = false;
              this.performSaveStep();
            }
          }, 1000);
        }
      }
      if (
        this.form.part1complete !== undefined &&
        this.form.part1complete === true
      ) {
        this.menuItems[0].isValid = true;
      }
    }
    if (
      this.userInfo.data !== undefined &&
      this.userInfo.data.form !== undefined
    ) {
      Object.assign(this.form, this.userInfo.data.form);
      setTimeout(() => {
        if (
          this.form.projectTitle !== '' &&
          this.form.projectTitle !== null &&
          this.form.projectSummary !== '' &&
          this.form.projectSummary !== null &&
          this.form.projectEndMonth !== '' &&
          this.form.projectEndMonth !== null &&
          this.form.projectEndYear !== '' &&
          this.form.projectEndYear !== null &&
          ((this.form.fundingAvailable &&
            this.form.supportType !== '' &&
            this.form.supportType !== 7 &&
            this.form.supportType !== 8 &&
            this.form.supportType !== 9 &&
            this.form.supportType !== -9 &&
            this.form.grantNumber !== '' &&
            this.form.grantNumber !== null) ||
            !this.form.fundingAvailable) &&
          (this.hasResearchArea ||
            this.form.cellDeath ||
            this.form.cellStimulus ||
            this.form.type1Diabetes ||
            this.form.tissueEngineering ||
            this.form.alphaCells ||
            this.form.geneticsGenomics ||
            this.form.otherArea) &&
          this.userInfo.data.docs.length > 0
        ) {
          this.menuItems[1].isValid = true;
        } else {
          this.menuItems[1].isValid = false;
        }
      }, 1000);
    }
  }

  private processStep(stepData: any) {
    if (stepData.id === 1) {
      this.menuItems[0].isValid = stepData.isValid;
    }
    if (stepData.id === 2) {
      this.file = stepData.file;
      if (
        store.userInfo.data !== undefined &&
        store.userInfo.data.docs.length === 0 &&
        (this.file === null || this.file.length === 0)
      ) {
        stepData.isValid = false;
        if (this.form.part2complete !== false) {
          this.performSaveStep();
        }
        this.menuItems[stepData.id - 1].isValid = stepData.isValid;
        if (stepData.isValid) {
          if (!this.hasResearchArea) {
            stepData.isValid = false;
            this.menuItems[stepData.id - 1].isValid = false;
          }
        }
        if (
          store.userInfo.data !== undefined &&
          store.userInfo.data.docs.length === 0 &&
          (this.file === null || this.file.length === 0)
        ) {
          stepData.isValid = false;
          this.menuItems[stepData.id - 1].isValid = false;
        }
        this.menuItems[1].isValid = stepData.isValid;
      }
    }
    setTimeout(() => {
      Object.assign(this.form, stepData.formData);
      this.menuItems[stepData.id - 1].isValid = stepData.isValid;
      this.file = stepData.file;
      if (stepData.id === 2) {
        this.menuItems[stepData.id - 1].isValid = stepData.isValid;
        if (stepData.isValid) {
          if (!this.hasResearchArea) {
            stepData.isValid = false;
            this.menuItems[stepData.id - 1].isValid = false;
          }
        }
        if (
          store.userInfo.data !== undefined &&
          store.userInfo.data.docs.length === 0 &&
          (this.file === null || this.file.length === 0)
        ) {
          stepData.isValid = false;
          this.menuItems[stepData.id - 1].isValid = false;
        }
      }
    }, 500);
  }
}
